<app-menu-bar></app-menu-bar>

<p-panel header="Procedimentos Iniciais" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar a plataforma">
            <tr>
                <td>
                    <img src="../../assets/images/PaginaInicial.jpg" class="ImagemPadrao">
                </td>
                <td>
                    <p>
                        Para acessar a plataforma, será necessário acessar através de um navegador (browser). </p>
                       <p> Endereço: https://acelerador-tco.vetorit-solucoes.com.br/ </p>
                </td>
            </tr>
        </p-tabPanel>
        <p-tabPanel header="Verificando a versão da aplicação">
            <td>
                <img src="../../assets/images/VerificandoVersao.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>
                    Na tela inicial (tela de login), no canto inferior a direita, e possível visualizar a versão da aplicação (incluindo as versões dos componentes do produto).
                </p>
            </td>
        </p-tabPanel>
        <p-tabPanel header="Efetuar login">
            <td>
                <img src="../../assets/images/PaginaInicial.jpg" class="ImagemPadrao"><BR>
            </td>
            <td>
                <p>
                    Para efetuar o login na aplicação, deverá ser informado o usuário e a senha.
                </p>
                <p>
                    Após o preenchimento dessas informações, clicar no botão "Entrar".
                </p>
                <p>
                    Caso o login seja efetuado com sucesso, automaticamente será redirecionado para a tela de processamento.
                </p>
            </td>
        </p-tabPanel>
        <p-tabPanel header="Menus disponíveis">
            <td>
                <img src="../../assets/images/Menus.jpg" class="ImagemPadrao"><BR>
            </td>
            <td>
                Uma vez que seja feito o login na aplicação, estarão disponíveis os menus abaixo:<BR>
                <ol>
                    <li>Configuração - Através desse menu o usuário será capaz de consultar o CNPJ x Contribuinte de cada companhia. Além disso será possível fazer alguma manutenção dos dados.</li>
                    <li>Grupos - Através desse menu o usuário será capaz de consultar os dados do grupo a que pertence. Além disso será possível fazer alguma manutenção dos dados.</li>
                    <li>Usuários - Através desse menu o usuário será capaz de fazer a manutenção de usuários, compreendendo a inclusão, alteração e exclusão de usuários.</li>
                    <li>Processamento - Através desse menu o usuário poderá acompanhar os processamentos em execução, submeter um novo processamento, consultar processamentos executados anteriormente, realizar upload de arquivos, etc.</li>
                    <li>Abrir novo ticket - Através desse menu o usuário será capaz de realizar a abertura de um ticket para reportar eventualmente uma ocorrência na aplicação. Ressaltando que só devem ser abertos ticket se tratando de erros de aplicação.</li>
                    <li>Ajuda - Através desse menu o usuário poderá esclarecer dúvidas sobre o funcionamento do produto.</li>
                </ol>
            </td>
        </p-tabPanel>
    </p-tabView>
</p-panel>


<p-panel header="Definindo Escopo TCO" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar o menu Importar Escopo TCO">
            <td>
                <img src="../../assets/images/MenuEscopo.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Através do menu principal, acessar o menu denominado "Importar Escopo TCO".</p>
                <p>No exemplo apresentado será usado a tela de processamento, todavia o mesmo procedimentos e aplicável a qualquer tela do portal.</p>
                <p> Observação: A definição do escopo é aplicável somente ao processamento do arquivo. </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Importar Arquivo">
            <td>
                <img src="../../assets/images/importarescopo.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Clicar no botão "Importar".</p>
            
            </td>
        </p-tabPanel>
    </p-tabView>
</p-panel>

<p-panel header="Criando uma programação de Carga" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar o menu Processamento">
            <td>
                <img src="../../assets/images/MenuProcessamento.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>
                    Através do menu principal, acessar o menu denominado "Processamento".
                </p>
            </td>
        </p-tabPanel>
        <p-tabPanel header="Clicar no botão Adicionar">
            <td>
                <img src="../../assets/images/BotãoAdicionar.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>
                    Após a abertura da janela de processamento, clicar no botão "Adicionar".
                </p>
            </td>
        </p-tabPanel>
        <p-tabPanel header="Selecionar companhia desejada">

            <td>
                <img src="../../assets/images/ProgramacaoCarga.jpg" class="ImagemPadrao">
            </td>

            <td>
                <p>Seleciona companhia.</p>

                 <p> Seleciona os dados que serão enviados. </p>

                 <p> Após selecionar todas as informações, clicar no botão "Salvar" </p>

            </td>

        </p-tabPanel>
    </p-tabView>
</p-panel>



<p-panel header="Adicionando Arquivos" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar o menu Processamento">
            <td>
                <img src="../../assets/images/MenuProcessamento.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Através do menu principal, acessar o menu denominado "Processamento".</p>
            </td>
        </p-tabPanel>
        <p-tabPanel header="Upload de Arquivos">
            <td>
                <img src="../../assets/images/BotãoUpload.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de Upload.</p>
                <p>Clicar no botao com ícone de Upload.</p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Selecionar Arquivo">
            <td>
                <img src="../../assets/images/SelecionarArquivo.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Clicar no botão "Selecionar Arquivo".</p>
            
            </td>
        </p-tabPanel>

        <p-tabPanel header="Escolha o Arquivo">
            <td>
                <img src="../../assets/images/Upload2.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Seleciona o arquivo desejado.</p>
                <p>Clicar em "Abrir".</p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Definir o tipo de obrigação">
            <td>
                <img src="../../assets/images/Upload3.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p> Seleciona o tipo de obrigação. </p>
                <p>Clicar no botão com ícone de "Salvar"</p>
            </td>
        </p-tabPanel>
        
    </p-tabView>
</p-panel>


<p-panel header="Executando Funcionalidades do Processamento de Carga " [toggleable]="true" [collapsed]="true">
<p-tabView>
    <p-tabPanel header="Acessar o menu Processamento">
     <td>
        <img src="../../assets/images/MenuProcessamento.jpg" class="ImagemPadrao">
         </td>
        <td>
            <p> Através do menu principal, acessar o menu denominado "Processamento". </p>
    </p-tabPanel>

    <p-tabPanel header="Iniciar programação">
     <td>
         <img src="../../assets/images/Execucao1.jpg" class="ImagemPadrao">
         </td>
    <td>
            <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de Iniciar programação.</p>
            <p>Clicar no ícone de Iniciar programação.</p>
    </td>
    </p-tabPanel>



    <p-tabPanel header="Log de Processamento">
             <td>
            <img src="../../assets/images/Execucao3.jpg" class="ImagemPadrao">
             </td>
                <td>
                <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de Log de Processamento.</p>
                <p>Clicar o botão com ícone de Log de processamento.</p>
                <p>Observação: O ícone que representa a tela de Log de Processamento só pode ser acessado para verificar as informações após a criação e processamento da carga. </p>
                 </td>
    </p-tabPanel>

    <p-tabPanel header="Verificando Status de Protocolo">
                <td>
                <img src="../../assets/images/Execucao2.jpg" class="ImagemPadrao">
                </td>
                <td>
                <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de Verifica Status </p>
                <p>Clicar o botão com ícone de Verifica Status.</p>
                <p>Observação: O ícone que representa a tela de Status de Protocolo só pode ser acessado para verificar as informações após a criação e processamento da carga. </p>


                </td>
    </p-tabPanel>

    <p-tabPanel header="Verificando Avaliação de Prontidão">
        <td>
            <img src="../../assets/images/avaliacaoprontidao.jpg" class="ImagemPadrao">
        </td>
        <td>
            <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de avaliação de prontidão</p>
            <p>Seleciona o ícone de avaliação de prontidão </p>
            <p>Observação: O ícone que representa a tela de Avaliação de Prontidão só pode ser acessado para verificar as informações após a criação e processamento da carga.</p>
            
        </td>
    </p-tabPanel>
    

    <p-tabPanel header="Verificando Processamentos">
        <td>
        <img src="../../assets/images/Execucao4.jpg" class="ImagemPadrao">
        </td>
        <td>
        <p>Dentro da lista de processamentos disponíveis, localizar o botão com ícone de Processamentos Solicitados </p>
        <p>Seleciona o botão com ícone de Processamentos Solicitados.</p>

        </td>
</p-tabPanel>

    </p-tabView>
    </p-panel>


<p-panel header="Filtrando os dados apresentados na janela" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar o menu Processamento">
            <td>
                <img src="../../assets/images/MenuProcessamento.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Através do menu principal, acessar o menu denominado "Processamento".</p>
                <p>No exemplo apresentado será usado a tela de processamento, todavia o mesmo procedimentos e aplicável a qualquer tela do portal.</p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Escolher a coluna que se desejar filtrar">
            <td>
                <img src="../../assets/images/FiltrarColunas1.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Ao escolher a coluna que se deseja filtrar, bastar clicar no funil para que seja apresentado o quadro de definição do filtro.</p>
                <p>Próximo dessa opção, também é possível mudar a ordenação que está sendo apresentado na tela, clicando diretamente nas setas para cima e para baixo.</p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Preencher os dados do filtro">
            <td>
                <img src="../../assets/images/FiltrarColunas2.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Preencher o valor que se deseja considerar no filtro. Adicionalmente as condições, exemplo "contenha", "igual a", "iniciado com" e assim por diante.</p>
                <p>Após definido os argumentos para o filtro, clicar no botão "Apply".</p>
            </td>
        </p-tabPanel>
    </p-tabView>
</p-panel>


<p-panel header="Abrindo Chamados" [toggleable]="true" [collapsed]="true">
    <p-tabView>
         <p-tabPanel header="Realizar Login">
            <td>
                <img src="../../assets/images/TelaInicial.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>  Através da tela de acesso a plataforma, realize o login. </p>
            </td>
        </p-tabPanel>

         <p-tabPanel header="Selecionar o menu de Chamados">
            <td>
                <img src="../../assets/images/IconeChamados.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Através do menu principal,selecione o ícone de chamados. </p>
                <p> Observação:Serão listado os chamados já abertos caso possuam; o usuário Admin consegue 
                listar todos os chamados e o usuário de um grupo verá somente os chamados pertinentes ao 
                grupo em que está configurado  </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Abertura de Chamados">
            <td>
                <img src="../../assets/images/Chamados1.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>Para abertura de um novo chamado, selecione o ícone de Novo. </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Novo de Chamado">
            <td>
                <img src="../../assets/images/Chamados2.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>  O sistema apresentará uma tela para a criação de um novo chamado, onde deverão ser informados o título,
                     o aplicativo e a descrição do problema/erro.</p>
                     <p> Após os devidos preenchimentos, clicar em Salvar.</p>
            </td>
        </p-tabPanel>
        
        <p-tabPanel header="Editar Chamado">
            <td>
                <img src="../../assets/images/Chamados3.jpg" class="ImagemPadrao">
            </td>
           <td>
                <p> Com o chamado já aberto é possível realizar edições, como por exemplo prioridade (baixa, média e alta),
                    e até mesmo incluir novos anexos, na coluna Editar clicar no ícone . </p>
                     <p> Também é possível interações entre usuário e a pessoa que está atendendo o chamado,
                         na coluna “Comentários” clicar no ícone </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Fechar Chamado">
            <td>
                <img src="../../assets/images/Chamados4.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p> Pra fechar o chamado, clicar no icone de cadeado na última coluna. </p>
            </td>
        </p-tabPanel>
    </p-tabView>
</p-panel>

<p-panel header="Funcionalidade de Reset de Senha e Seleção de Ambiente" [toggleable]="true" [collapsed]="true">
    <p-tabView>

        <p-tabPanel header="Reset de Senha">
            <td>
                <img src="../../assets/images/TelaInicial.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p> Através da tela de acesso a plataforma, clique em "Esqueceu a senha" </p>
                <p> Observação: Nessa tela temos o acesso a plataforma, utilizando as credenciais (usuário e senha).
                     Ainda nessa tela é possível informar o ambiente a qual os aceleradores de implantação (Avatax e TCO) fará comunicação. 
                     Observando que o ambiente Sandbox é utilizado durante a implantação do Avatax e TCO,
                      e o ambiente de produção quando for realizar a promoção do ambiente. 
                    A aplicação Portal de Projetos não é afetado pela seleção de ambiente Avalara./p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Acionamento do link Esqueceu a senha">
            <td>
                <img src="../../assets/images/Reset1.jpg" class="ImagemPadrao">
            </td>
           <td>
                <p> Após o acionamento desse item, o sistema apresentará essa tela
                     onde o usuário que esqueceu a senha ou deseja fazer o reset da mesma poderá informar os dados 
                     de identificação para realizar o reset. 
                     É exigido o nome do usuário e o e-mail da mesma forma como está no cadastro do usuário. </p>
                     <p>Após preencher os campos, clique em "Enviar" para gerar uma senha temporária  </p>
            </td>
        </p-tabPanel>

         <p-tabPanel header="Redefinição de Senha">
            <td>
                <img src="../../assets/images/Reset3.jpg" class="ImagemPadrao">
            </td>
           <td>
                <p> Após o envio, o usuário receberá um e-mail com um link para realização de reset de senha. </p>
            </td>
        </p-tabPanel>

         <p-tabPanel header="Digite Nova Senha">
            <td>
                <img src="../../assets/images/Reset4.jpg" class="ImagemPadrao">
            </td>
           <td>
                <p> Nessa tela você irá informar a nova senha e confirmar na sequência. </p>
                <p> Após o procedimento, o usuário poderá se logar normalmente.</p>
            </td>
        </p-tabPanel>
        </p-tabView>
</p-panel>

<p-panel header="Liberando acesso para novos profissionais" [toggleable]="true" [collapsed]="true">
    <p-tabView>
        <p-tabPanel header="Acessar a manutenção de Usuários">
            <td>
                <img src="../../assets/images/MenuGrupos.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p>  Através do menu principal, acessar o menu denominado "Usuários". </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Listagem de Usuários">
            <td>
                <img src="../../assets/images/ManutencaoUsuario.jpg" class="ImagemPadrao">
            </td>

            <td>
                <p> Nessa janela, para iniciar a inclusão de um novo usuário, deve-se clicar no botão "Adicionar". </p>
            </td>
        </p-tabPanel>

        <p-tabPanel header="Preencher as informações do novo usuário">
            <td>
                <img src="../../assets/images/InclusaoUsuario.jpg" class="ImagemPadrao">
            </td>

            <td>
                <p> Nessa janela, o usuário conseguirá fazer o preenchimento das informações do usuário.</p>
                <p> É obrigatório o preenchimento dos campos: Nome Usuário, Senha, Status, Acesso, Grupo e Email.</p>
            </td>

        </p-tabPanel>

        <p-tabPanel header="Gravando o usuário">
            <td>
                <img src="../../assets/images/InclusaoUsuario.jpg" class="ImagemPadrao">
            </td>
            <td>
                <p> Após o preenchimento dos campos, clicar no botão "Salvar". </p>
            </td>
        </p-tabPanel>
    </p-tabView>
</p-panel>

    